import { ConfigProvider, notification } from "antd"
import { ErrorBoundary } from "components/custom"
import { getAppLanguage, useInitializeApp } from "configs/useInitializeApp"
import FingerprintJS from "@fingerprintjs/fingerprintjs"
import { configs } from "configs"
import { useDispatch, useSelector } from "react-redux"
import { BrowserRouter } from "react-router-dom"
import PFRoutes from "routes"
import { inDevelopMode } from "utils/env"
import "antd/dist/reset.css"
import "./App.less"
import { useEffect, useMemo } from "react"
import { setFingerPrint, setGeoLocation } from "store/appSlice"
import { Spinner } from "components/common"
import themeV5 from "configs/themeV5"
import DateTime from "utils/dateTime"
import dayjs from "dayjs"
import duration from "dayjs/plugin/duration"
import relativeTime from "dayjs/plugin/relativeTime"
import utc from "dayjs/plugin/utc"
import advancedFormat from "dayjs/plugin/advancedFormat"
import customParseFormat from "dayjs/plugin/customParseFormat"
import localeData from "dayjs/plugin/localeData"
import weekday from "dayjs/plugin/weekday"
import weekOfYear from "dayjs/plugin/weekOfYear"
import weekYear from "dayjs/plugin/weekYear"
import quarterOfYear from "dayjs/plugin/quarterOfYear"
import isSameOrBefore from "dayjs/plugin/isSameOrBefore"
import isSameOrAfter from "dayjs/plugin/isSameOrAfter"
import isBetween from "dayjs/plugin/isBetween"
import localizedFormat from "dayjs/plugin/localizedFormat"
import { useGlobalSync } from "hooks/useGlobalSync"
import { usePostMeetingRecordingMutation } from "features/management/api"

dayjs.extend(advancedFormat)
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)
dayjs.extend(customParseFormat)
dayjs.extend(advancedFormat)
dayjs.extend(weekday)
dayjs.extend(localeData)
dayjs.extend(weekOfYear)
dayjs.extend(weekYear)
dayjs.extend(utc)
dayjs.extend(duration)
dayjs.extend(relativeTime)
dayjs.extend(quarterOfYear)
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)
dayjs.extend(isBetween)
dayjs.extend(localizedFormat)

const App = () => {
  const { direction } = useSelector(state => state.app.configs)
  const fingerprint = useSelector(state => state?.app?.fingerprint)
  const dispatch = useDispatch()
  const language = getAppLanguage()
  const [postMeetingRecording] = usePostMeetingRecordingMutation()
  useGlobalSync({ databaseName: null, finalApiCall: postMeetingRecording, pollInterval: 2 * 60 * 1000 })
  useInitializeApp()

  useEffect(() => {
    if (!language?.key) {
      window.location.replace("/" + configs.languages[0].key)
    }
  }, [])

  useEffect(() => {
    if (configs?.locationRequired) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          position => {
            dispatch(
              setGeoLocation({
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
              })
            )
          },
          err => {
            return
          }
        )
      } else {
        notification.error({ message: "Geolocation is not supported by this browser." })
      }
    }
  }, [])

  useEffect(() => {
    const setFp = async () => {
      const fp = await FingerprintJS.load()
      const { visitorId } = await fp.get()
      dispatch(setFingerPrint(visitorId))
    }
    setFp()
  }, [])
  const renderPFRoutes = useMemo(() => {
    return !fingerprint ? (
      <Spinner size="medium" fullPageSpinner />
    ) : inDevelopMode ? (
      <PFRoutes />
    ) : (
      <ErrorBoundary>
        <PFRoutes />
      </ErrorBoundary>
    )
  }, [fingerprint, inDevelopMode])

  useEffect(() => {
    // DateTime.locale(language?.locale)
    const htmlElement = document.getElementsByTagName("html")[0]
    htmlElement.lang = language?.locale
    htmlElement.dir = language?.rtl ? "rtl" : "ltr"
    document.getElementById("link-app-fonts").href = language?.font
  }, [language?.locale])

  return (
    <ConfigProvider locale={language?.locale} direction={direction} theme={themeV5}>
      <BrowserRouter basename={language?.key || configs.languages[0].key}>{renderPFRoutes}</BrowserRouter>
    </ConfigProvider>
  )
}

export default App
